const actions = {
    GET_ROUTE_REPORT_STORED_DATA: "storedData/GET_ROUTE_REPORT_STORED_DATA",
    SET_ROUTE_REPORT_STORED_DATA: "storedData/SET_ROUTE_REPORT_STORED_DATA",


    SET_ROUTE_STORED_DATA: "storedData/SET_ROUTE_STORED_DATA",
    SET_ROUTE_PIN_DETAILS: "storedData/SET_ROUTE_PIN_DETAILS",
    SET_PAGINATION_PAGE_WORKSPACE_LIST: 'storedData/SET_PAGINATION_PAGE_WORKSPACE_LIST',


    SET_INITIAL_ROUTE_PIN_DETAILS: "storedData/SET_INITIAL_ROUTE_PIN_DETAILS",
    SET_INITIAL_PAGINATION_PAGE_WORKSPACE_LIST: "storedData/SET_INITIAL_PAGINATION_PAGE_WORKSPACE_LIST",
    SET_INITIAL_ROUTE_REPORT_STORED_DATA: "storedData/ROUTE_REPORT_STORED_DATA",
    SET_INITIAL_ROUTE_STORED_DATA: "storedData/ROUTE_STORED_DATA",
}

export default actions